export const USER_STATUS = {
	GUEST: 'guest',
	REGISTERED: 'registered',
	VIP: 'vip',
	GOLDEN_TICKET: 'golden-ticket'
};



// WEBPACK FOOTER //
// ./enums/UserStatus.js